// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

@Component({
    selector: 'app-board-approval-rules',
    templateUrl: './board-approval-rules.component.html',
    styleUrls: ['./board-approval-rules.component.scss']
})
export class BoardApprovalRulesComponent {
    @Input() visible: boolean;
    @Input() boardApprovalProcess: string;
    @Output() closeBoardApprovalPopup = new EventEmitter<boolean>();

    iconClose = IconConstants.CLOSE;

    onHidden(): void {
        this.visible = false;
        this.closeBoardApprovalPopup.emit(false);
    }
}
